import { useState, useMemo, useRef } from "react";
import { useTranslate } from "@refinedev/core";

import { usePaginatedTable, useQueryParams } from "@shared/hooks";
import { ModalRef } from "@shared/components";
import { Catalog } from "@modules/catalogs/types";

export function useCatalogList() {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);

  const createCatalogModalRef = useRef<ModalRef>(null);
  const editCatalogModalRef = useRef<ModalRef>(null);

  const translate = useTranslate();
  const { getQueryParams } = useQueryParams();

  const { rows, loading, refetch, ...tableProps } = usePaginatedTable<Catalog>({
    resource: "v1/plan_admin",
    filters: getQueryParams(),
  });

  const dataToExport = useMemo(() => {
    return selectedRows.length > 0
      ? rows.filter((row) => selectedRows.includes(row.id))
      : rows;
  }, [selectedRows, rows]);

  return {
    rows,
    loading,
    tableProps,
    selectedRows,
    dataToExport,

    createCatalogModalRef,
    editCatalogModalRef,
    refetch,
    setSelectedRows,
    translate,

  };
}
